import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-times",
  "use": "icon-times-usage",
  "viewBox": "0 0 10 10",
  "content": "<symbol viewBox=\"0 0 10 10\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-times\">\n<path d=\"M0.812023 0L0 0.812023L4.18798 5L0 9.18798L0.812023 10L5 5.81202L9.18798 10L10 9.18798L5.81202 5L10 0.812023L9.18798 0L5 4.18798L0.812023 0Z\" fill=\"#465669\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol